import { render, staticRenderFns } from "./PartidaList.vue?vue&type=template&id=0f85c35a&"
import script from "./PartidaList.vue?vue&type=script&lang=js&"
export * from "./PartidaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports